import { getVendorColor } from "../charts/chartColors";
import { VendorIcon } from "../consumption/VendorIcon";
import styles from "./ProviderName.module.css";

/**
 * A provider's name with its icon in front, as every place that names a provider should show it. The icon sits on a tile
 * tinted with the provider's colour, the same as on My Tools, so a provider can be picked out of a long list at a glance.
 * The icon is decorative: the name is always there in text.
 *
 * @param props.vendorId - The provider's id, in any case.
 * @param props.name - The provider's display name.
 */
export function ProviderName({ vendorId, name }: { vendorId: string; name: string }): React.JSX.Element {
  return (
    <span className={styles.name}>
      <span className={styles.tile} style={{ "--provider-colour": getVendorColor(vendorId, 0) } as React.CSSProperties} aria-hidden="true">
        <VendorIcon vendorId={vendorId.toLowerCase()} className={styles.icon} />
      </span>
      {name}
    </span>
  );
}
